import React from 'react';
import { CSVLink, CSVDownload } from "react-csv";
import { validate_m, validate_k, validate_r } from "./Uvalidation"
import 'katex/dist/katex.min.css';
import Graph from '../graph/graph'
import {
  Message,
} from 'semantic-ui-react'

const { InlineMath, BlockMath } = require('react-katex')
const gamma = require('gamma')
const nbd_cumulative_threshold = 0.995
const nbd_under_threshold = 0.0001
const max_count = 10

interface IProps {
  data: any;
};

const get_nbd = (m: number, k: number, r: number) => {

  //   if (!validate_m(m)) {
  //     console.log("validate m success.")
  //   } else {
  //     console.log("validate m failure.")
  //   }
  //
  //   if (!validate_k(k)) {
  //     console.log("validate k success.")
  //   } else {
  //     console.log("validate k failure.")
  //   }
  //
  //   if (!validate_r(r)) {
  //     console.log("validate r success.")
  //   } else {
  //     console.log("validate r failure.")
  //   }
  //
  return (1 + m / k) ** (-k) * gamma(k + r) * (m / (m + k)) ** r / gamma(r + 1) / gamma(k);
}


var get_nbd_list = (m: number, k: number) => {

  var array = []

  for (var r = 0; r < max_count; r++) {
    var value = Number(((1 + m / k) ** (-k) * gamma(k + r) * (m / (m + k)) ** r / gamma(r + 1) / gamma(k)).toFixed(3))
    if (value < nbd_under_threshold) {
      return array
    } else {
      array.push(value)
    }

    if (array.reduce((a, b) => a + b) > nbd_cumulative_threshold) {
      return array
    }
  }
  return array.filter((a) => a > nbd_under_threshold)
}


var get_cumulative_list = (list: number[], delta = 1) => {
  var cumulative_list = []
  for (var i = 0; i < list.length; i++) {
    cumulative_list.push(
      list.slice(0, i + 1).reduce((a, b) => (a + b)) * delta < 1 ? list.slice(0, i + 1).reduce((a, b) => (a + b)) * delta : 1
    )
  }
  return cumulative_list
}



const get_data = (m: number, P0: number, k: number) => {

  const data = []
  const nbd_data = get_nbd_list(m, k)
  const nbd_cumulative_data = get_cumulative_list(nbd_data)

  for (var r = 0; r < max_count; r++) {

    data.push(
      {
        name: r,
        pdf: nbd_data[r],
        cdf: nbd_cumulative_data[r],
      }
    )
    if (nbd_cumulative_data[r] > nbd_cumulative_threshold) {
      break;
    }
  }

  return data
}

class UNbd extends React.Component<IProps, {}> {

  constructor(props: IProps) {
    super(props);
    this.state = {
    };
    console.log("nbd.tsx function k  = " + this.props.data.k)
    console.log("nbd.tsx function P0 = " + this.props.data.P0)
    console.log("nbd.tsx function m  = " + this.props.data.m)
  }

  render() {
    console.log(this.props.data.k)
    var data = get_data(this.props.data.m, this.props.data.P0, this.props.data.k)
    return (
      <div>
        <Graph data={data} />
        <div className='message_container'>
          <CSVLink
            filename={"nbd.csv"}
            data={data}
          >
            <Message
              info
              header='Download'
              content='クリックしてNBDの結果をダウンロードする'
            />
          </CSVLink>
        </div>
      </div>
    );
  }
}

export default UNbd;
